import { LoaderFunctionArgs } from "react-router-dom";
import { apiEndpoints } from "@/services/api/api";
import { LecturerFinanceLoaderData } from "../types/lecturerFinanceTypes";

export async function lecturerFinanceLoader({
  request,
}: LoaderFunctionArgs): Promise<LecturerFinanceLoaderData> {
  const url = new URL(request.url);
  const tab = url.searchParams.get("tab") ?? "all-sales";
  const page = Number(url.searchParams.get("page") ?? 1);
  const courseId = url.searchParams.get("courseId") ?? null;

  const [coursesRes, ordersRes] = await Promise.all([
    apiEndpoints.lecturerGetCourses({
      pageNumber: 1,
      pageSize: 100,
      search: null,
      publishStatus: null,
    }),
    apiEndpoints.lecturerGetOrders({
      pageNumber: page,
      pageSize: 10,
      courseId: tab === "courses" ? courseId : null,
    }),
  ]);

  if (!coursesRes.success) throw new Error(coursesRes.message);
  if (!ordersRes.success) throw new Error(ordersRes.message);

  return {
    courses: coursesRes.data,
    orders: ordersRes.data,
  };
}
